import PropTypes from 'prop-types';
import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import EventBadgeList from './EventBadgeList';
import HotelBuildBid from './HotelBuildBid';

function compareGroupEvents(a, b) {
  if (a.group_name < b.group_name) {
    return -1;
  }
  if (a.group_name > b.group_name) {
    return 1;
  }
  // a must be equal to b
  return 0;
}

class GroupsHotelPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTabIndex: 0, // Initialize with default value
    };
  }


  handleTabSelect = (selectedIndex) => {
    this.setState({ selectedTabIndex: selectedIndex });
  };

  render() {
    if (!this.props.selectedEvent) {
      return (
        <div className="bid-panel-big">
          <span></span>
        </div>
      );
    }
    const fetchingHotels = this.props.fetchingHotels;
    const groupEvents = this.props.selectedEvent.related_group_events;
    const groupHotelBids = groupEvents.sort(compareGroupEvents).map((event, i) => (
      <Tab key={event.id} eventKey={i} title={event.group_name}>
        <HotelBuildBid
          event={event}
          selectedTabIndex={this.state.selectedTabIndex}
          bidsvalue={this.props.selectedTour.bids}
          currentEvent ={this.props.selectedEvent.events}
          group_id = {this.props.groups[this.state.selectedTabIndex].id}
          event_id = {this.props.selectedEvent.related_group_events[this.state.selectedTabIndex].id}
          city_id = {event.parent}
          needFetch={!(event.id in fetchingHotels)}
          isFetching={event.id in fetchingHotels ? fetchingHotels[event.id] : false}
          hotels={event.id in this.props.hotels ? this.props.hotels[event.id] : []}
          selectHotel={this.props.selectHotel}
          favoriteHotel={this.props.favoriteHotel}
          searchHotels={this.props.searchHotels}
          editGroupEvent={this.props.editGroupEvent}
          showPrefs={this.props.showPrefs}
          tourData={this.props.tours}
          editMember={this.props.editMemberModal}
          saveRoomPreferences={this.props.saveRoomPreferences}
          dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
          selectedTourId={this.props.groups[0].tour}
          selectedTour={this.props.selectedTour}
          addBidDetail={this.props.addBidDetail}
          addMultipleBidDetail={this.props.addMultipleBidDetail}
          requestquestions={this.props.requestquestions}
          requestTourquestions={this.props.requestTourquestions}
          AddedQuestions={this.props.AddedQuestions}
          createQuestions={this.props.createQuestions}
          mapQuestion={this.props.createQuestionsmapping}
          ques={this.props.questions}
          addQuestion={this.props.addQuestion}
          addedQuestion={this.props.addedQuestion}
          removeQuestion={this.props.removeQuestion}
          removeAddedQuestion={this.props.removeAddedQuestion}
          selectedQuest={this.props.checkBoxQuestion}
          addBulkMultipleBidDetail={this.props.addBulkMultipleBidDetail}
          saveCityNotes={this.props.saveCityNotes}
          DeleteEventNotes={this.props.DeleteEventNotes}
          requestBidsets ={this.props.requestBidsets}
          // {...this.props}
        />
      </Tab>
    ));
    return (
      <div>

        <div className="define-bid-instruction-text">
          <h4>
            Please DEFINE TABLE first before selecting hotel.
          </h4>
        </div>
        <div className="bid-panel-big">
          <div className="bid-details">
          <Tabs defaultActiveKey={0} onSelect={this.handleTabSelect}>{groupHotelBids}</Tabs>
          </div>
          <div className="bid-info">
            <EventBadgeList
              parentId={this.props.selectedEvent.id}
              events={this.props.selectedEvent.events}
            />
            <div>
              <hr />
              <p>
                <i style={{ color: 'green' }} className="fa fa-check-circle" />indicates hotel is
                verified on Catch
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GroupsHotelPicker.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedEvent: PropTypes.object,
  fetchingHotels: PropTypes.object.isRequired,
  hotels: PropTypes.object.isRequired,
  selectHotel: PropTypes.func.isRequired,
  searchHotels: PropTypes.func.isRequired,
  favoriteHotel: PropTypes.func.isRequired,
  editGroupEvent: PropTypes.func.isRequired,
  showPrefs: PropTypes.func.isRequired,
  requestquestions: PropTypes.func.isRequired,
  requestTourquestions: PropTypes.func.isRequired,
  AddedQuestions: PropTypes.func.isRequired,
  removeQuestion: PropTypes.func.isRequired,
};

GroupsHotelPicker.defaultProps = {
  groups: [],
  selectedEvent: null,
};

export default GroupsHotelPicker;



// WEBPACK FOOTER //
// src/routes/tours/components/GroupsHotelPicker.js